import { cn } from './chunk-FFX3LZW7.js';
import { jsx } from 'react/jsx-runtime';

function Skeleton({ className, ...props }) {
  return /* @__PURE__ */ jsx("div", { className: cn("animate-pulse rounded-md bg-muted", className), ...props });
}

export { Skeleton };
//# sourceMappingURL=chunk-7AXDPYRM.js.map
//# sourceMappingURL=chunk-7AXDPYRM.js.map